import type React from 'react';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import { useUnauthenticatedSignForm } from '#src/app/pages/petitionDetails/shared/hooks';

import { Respond } from '../Respond';

import { SideClosed } from './SideClosed';
import { SideSigned } from './SideSigned';
import { SideUnsigned } from './SideUnsigned';
import { SideVictory } from './SideVictory';

const SideInner: React.FC<EmptyProps> = () => {
	const {
		data: {
			petition: { status },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { decisionMaker, signed },
	} = usePetitionDetailsPageUserData();
	const {
		data: { enabled: unauthenticatedSignFormEnabled },
	} = useUnauthenticatedSignForm();

	if (decisionMaker) {
		return <Respond />;
	}
	if (status === 'CLOSED') {
		return <SideClosed />;
	}
	if (status === 'VICTORY') {
		return <SideVictory />;
	}
	if (signed && !unauthenticatedSignFormEnabled) {
		return <SideSigned />;
	}
	return <SideUnsigned />;
};

type Props = {
	containerRef?: React.RefObject<HTMLDivElement | null>;
};

export const Side: React.FC<Props> = ({ containerRef }) => {
	return (
		<div
			ref={containerRef}
			className="elevation-floating dark:border-stroke-weaker bg-background-base rounded-lg p-8 dark:border"
		>
			<SideInner />
		</div>
	);
};
